module.exports = __webpack_public_path__ + "img/avatar-s-27.924e511a.jpg";